module.exports = __webpack_public_path__ + "static/media/a7x_monitors.362efdbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/audio/a7x_monitors.png
// module id = 329
// module chunks = 0